import { Component, Input, OnInit } from '@angular/core';
import { SignalQualityCalculatorService } from 'libs/portal/src/services/signal-quality-calculator.service';
import { SignalStrengthCalculatorService } from 'libs/portal/src/services/signal-strength-calculator.service';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';

@Component({
  selector: 'tools-device-full-detail',
  templateUrl: './device-full-detail.component.html',
  styleUrls: ['./device-full-detail.component.scss'],
})
export class DeviceFullDetailComponent implements OnInit {
  @Input() data: any;

  constructor(private tools: ToolsService, private signalStrengthCalculator: SignalStrengthCalculatorService, private signalQualityCalculator: SignalQualityCalculatorService) {}

  ngOnInit() {
    if (this.data?.KaDevice?.AggregatedTowerPing?.CellTower) {
      this.data.KaDevice.AggregatedTowerPing.CellTower.Network = this.tools.GetNetworkNameByMNC(this.data?.KaDevice?.AggregatedTowerPing?.CellTower.MNC);
    }

    if (this.data?.KaDevice?.RingfenceLog?.Timestamp) {
      this.data.KaDevice.RingfenceLog.FormattedTimestamp = this.tools.ParseAPIDateWithTimezone(this.data.KaDevice.RingfenceLog.Timestamp);
    }

    if (this.data?.CdrDevice?.LastSnapshotEvent) {
      this.data.CdrDevice.LastSnapshotEvent.SignalStrength = this.signalStrengthCalculator.GetSignalPercentage(this.data.CdrDevice.LastSnapshotEvent.SignalStrength);
      this.data.CdrDevice.LastSnapshotEvent.SignalQuality = this.signalQualityCalculator.GetSignalPercentage(this.data.CdrDevice.LastSnapshotEvent.SignalQuality);
    }
  }

  containerToggled(ev) {
    if (ev.currentTarget.parentElement.style.height == '100%') {
      ev.currentTarget.parentElement.style.height = 'auto';
    } else {
      ev.currentTarget.parentElement.style.height = '100%';
    }
  }
}
